import { Component, OnInit } from "@angular/core";

@Component({
  selector: "[sk-experience]",
  templateUrl: "./experience.component.html",
  styleUrls: ["./experience.component.css"],
})
export class ExperienceComponent implements OnInit {
  today: Date = new Date();
  currYearDiff: number;
  currMonthDiff: number;
  constructor() {}

  ngOnInit() {
    this.currYearDiff =
      this.today.getFullYear() - new Date(2018, 2, 18).getFullYear();
    this.currMonthDiff =
      this.today.getMonth() + 1 == 12 ? 0 : this.today.getMonth() + 1;
  }
}
